module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v13-latin-600.4e138ced.eot";